import * as React from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';

import { Dialog, DialogActions, DialogContent, DialogTitle } from 'components';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useDeleteZoneMutation } from 'store/apis';

interface ZoneDeleteDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  zoneId: number;
}

export const ZoneDeleteDialog = ({ visible = false, setVisible = () => {}, zoneId }: ZoneDeleteDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [deleteZone, { isLoading: loading_delete, isSuccess: success_delete, isError: error_delete }] =
    useDeleteZoneMutation();

  React.useEffect(() => {
    if (!loading_delete && success_delete && !error_delete) {
      setVisible(false);
    }
  }, [loading_delete, success_delete, error_delete]);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onDelete = () => {
    deleteZone({ orgSlug, id: zoneId });
  };

  return (
    <Dialog onClose={onClose} open={visible} fullScreen={false}>
      <DialogTitle>
        <Typography variant="h6" component="span">
          Confirm delete zone
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="subtitle2" color="textSecondary">
          Do you really want to delete this zone? This process cannot be undone.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => onClose(null, 'anyway')}
          sx={{
            paddingX: 2,
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={onDelete}
          disabled={loading_delete}
          endIcon={loading_delete && <CircularProgress color="inherit" size={14} />}
          sx={{
            paddingX: 2,
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
